import InnoIcons from "@InnoIcons/";
import { Tooltip } from "antd";
import PDF from "@assets/images/PDF.png";
import Word from "@assets/images/Word.png";
import Excel from "@assets/images/Excel.png";
import DWG from "@assets/images/DWG.png";
import DWF from "@assets/images/DWF.png";
import theme from "@theme/";

const FileTypeIcon = ({ fileType }) => {
  if (!fileType) return <span>-</span>;

  const type = fileType.toLowerCase();

  // Image files
  if (
    type.includes("image") &&
    !type.includes("dwg") &&
    !type.includes("dwf")
  ) {
    return (
      <Tooltip title="Image File">
        <InnoIcons.ImageIcon sx={{ fontSize: "18px", color: "#28AAE5" }} />
      </Tooltip>
    );
  }

  // PDF
  if (type.includes("pdf")) {
    return (
      <Tooltip title="PDF File">
        <img src={PDF} alt="Ingested" style={{ width: 22, height: 22 }} />
      </Tooltip>
    );
  }

  // Word
  // Word (DOC / DOCX)
  if (
    type.includes("word") ||
    type.includes("msword") ||
    type.includes("wordprocessingml")
  ) {
    return (
      <Tooltip title="Word File">
        <img src={Word} alt="Word" style={{ width: 22, height: 22 }} />
      </Tooltip>
    );
  }

  // Excel
  if (
    type.includes("excel") ||
    type.includes("sheet") ||
    type.includes("xls") ||
    type.includes("spreadsheetml")
  ) {
    return (
      <Tooltip title="Excel File">
        <img src={Excel} alt="Excel" style={{ width: 22, height: 22 }} />
      </Tooltip>
    );
  }

  // ✅ DWG (AutoCAD Drawing)
  if (
    type.includes("dwg") ||
    type.includes("vnd.dwg") ||
    type.includes("acad")
  ) {
    return (
      <Tooltip title="DWG Drawing">
        <img src={DWG} alt="DWG" style={{ width: 22, height: 22 }} />
      </Tooltip>
    );
  }

  // ✅ DWF (Design Web Format)
  if (type.includes("dwf") || type.includes("vnd.dwf")) {
    return (
      <Tooltip title="DWF File">
        <img src={DWF} alt="DWF" style={{ width: 22, height: 22 }} />
      </Tooltip>
    );
  }

  // ZIP
  if (type.includes("zip") || type.includes("rar")) {
    return (
      <Tooltip title="Compressed File">
        <InnoIcons.FolderZipIcon
          sx={{ fontSize: "18px", color: theme.colors.themeColor }}
        />
      </Tooltip>
    );
  }

  // Video
  if (type.includes("video") || type.includes("mp4")) {
    return (
      <Tooltip title="Video File">
        <InnoIcons.VideoLibraryIcon sx={{ fontSize: "18px" }} />
      </Tooltip>
    );
  }

  // Default
  return <span>{fileType}</span>;
};

export default FileTypeIcon;
